import React, { useEffect, useState } from 'react';

import { CommunityContract } from 'types/contracts';
import { FeeDataType, FeeType } from 'types/fees';

import FeesPreview from './FeesPreview';
import { useCareTypesContext } from '../CareTypesContext';

interface Props {
  type: FeeType;
}

const Fees = ({ type }: Props) => {
  const { careType, fees, contract } = useCareTypesContext();
  const [contractFee, setContractFee] = useState<FeeDataType | undefined>(undefined);

  useEffect(() => {
    const fee = careType?.fees?.find(
      (item: FeeDataType) =>
        item?.fee_type === type &&
        (item.contracts ?? []).some((contractItem: CommunityContract) => contractItem.id === contract?.id)
    );

    setContractFee(fee);
  }, [careType, contract, fees]);

  return <FeesPreview fee={contractFee} />;
};

export default Fees;
